(() => {
  function mount(root) {
    if (root.dataset.setupBound) return;
    root.dataset.setupBound = 'true';
    const drawer = root.querySelector('dialog');
    document.body.append(drawer);
    const appRoot = document.documentElement;
    let opener;
    let previousOverflow;
    const app = () => window.Alpine?.$data(appRoot);
    const money = cents => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const cleanMoney = cents => { const el = document.createElement('span'); el.innerHTML = money(cents); return el.textContent; };
    root.querySelectorAll('[data-setup-open]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      drawer.showModal();
      const item = Array.from(drawer.querySelectorAll('[data-setup-item]')).find(item => item.dataset.setupItem === button.dataset.setupOpen);
      if (item) drawer.querySelector('.battle-setup-drawer__items').scrollTop = item.offsetTop - drawer.querySelector('.battle-setup-drawer__header').offsetHeight;
    }));
    drawer.querySelector('[data-setup-close]').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const r = drawer.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) drawer.close();
    });
    drawer.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; opener?.focus({ preventScroll: true }); });
    drawer.querySelector('[data-setup-cart]').addEventListener('click', () => {
      drawer.close();
      const state = app();
      if (state?.updateCart) state.updateCart(true); else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    });
    drawer.querySelectorAll('[data-setup-item]').forEach(item => {
      const product = JSON.parse(item.querySelector('[data-setup-product]').textContent);
      const selects = Array.from(item.querySelectorAll('select'));
      const button = item.querySelector('[data-setup-add]');
      const status = item.querySelector('[data-setup-status]');
      const image = item.querySelector('img');
      let busy = false;
      selects.forEach(select => Array.from(select.options).forEach(option => { option.dataset.setupLabel = option.textContent; }));
      function syncOptions() {
        selects.forEach((select, index) => {
          Array.from(select.options).forEach(option => {
            if (!option.value) return;
            const matching = product.variants.filter(variant => variant.options[index] === option.value && selects.every((other, position) => position >= index || !other.value || variant.options[position] === other.value));
            option.disabled = !matching.some(variant => variant.available);
            option.textContent = option.dataset.setupLabel + (option.disabled ? matching.length ? ' (Sold out)' : ' (Unavailable)' : '');
          });
          if (select.selectedOptions[0]?.disabled) select.value = '';
        });
      }
      function chosen() { return selects.length ? product.variants.find(v => v.options.every((value, index) => value === selects[index].value)) : product.variants[0]; }
      function selectedImage(variant) {
        if (variant?.featured_image?.src) return variant.featured_image.src;
        if (selects.some(select => select.value)) {
          const matching = product.variants.filter(candidate => selects.every((select, index) => !select.value || candidate.options[index] === select.value));
          const preview = matching.find(candidate => candidate.available && candidate.featured_image?.src) || matching.find(candidate => candidate.featured_image?.src);
          if (preview) return preview.featured_image.src;
        }
        return product.featured_image;
      }
      function sync() {
        syncOptions();
        const variant = chosen();
        const complete = selects.every(select => select.value);
        button.disabled = busy || (complete && (!variant || !variant.available)) || !product.available;
        button.textContent = busy ? 'ADDING…' : !product.available || (complete && variant && !variant.available) ? 'SOLD OUT' : complete && !variant ? 'UNAVAILABLE' : complete ? 'ADD TO CART' : 'CHOOSE OPTIONS';
        item.querySelector('[data-setup-price]').textContent = cleanMoney(variant ? variant.price : product.price_min);
        const compare = item.querySelector('[data-setup-compare]');
        compare.hidden = !(variant && variant.compare_at_price > variant.price);
        compare.textContent = compare.hidden ? '' : cleanMoney(variant.compare_at_price);
        const nextImage = selectedImage(variant);
        if (image && nextImage) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = nextImage;
        }
      }
      selects.forEach(select => select.addEventListener('change', () => { status.textContent = ''; sync(); }));
      button.addEventListener('click', async () => {
        const missing = selects.find(select => !select.value);
        if (missing) { missing.focus({ preventScroll: true }); status.textContent = 'Choose ' + missing.getAttribute('aria-label').split(': ').pop().toLowerCase() + '.'; return; }
        const variant = chosen();
        if (busy || !variant?.available) return;
        busy = true; status.textContent = ''; sync();
        let added = false;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item. Try again.');
          added = true;
          status.textContent = 'Added ✓';
          drawer.querySelector('[data-setup-cart]').hidden = false;
          const state = app();
          if (state?.updateCart) await state.updateCart(false);
        } catch (error) { status.textContent = added ? 'Added ✓. View cart to review your item.' : error.message; }
        finally { busy = false; sync(); }
      });
      sync();
    });
  }
  function init() { document.querySelectorAll('[data-battle-setup]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
